import { Button } from 'antd';
import moment from 'moment';
import { FaBriefcase, FaRegClock, FaLocationArrow, FaLink, FaCalendarAlt } from 'react-icons/fa';
import { timePreferenceOptions } from '../../constant/global';
import './AppointmentFlow.css';
import './index.css';

const SelectApppointment = ({ selectedDate, handleDateChange, selectTime, setSelectTime, selectedDoctor }) => {
  const handleSelectTime = (time) => setSelectTime(time);

  const next28Days = Array.from({ length: 28 }, (_, i) => moment().clone().add(i + 1, 'days'));

  const fullName = selectedDoctor
    ? `Dr. ${(selectedDoctor.firstName || '')} ${(selectedDoctor.lastName || '')}`.trim() || 'Doctor'
    : 'Doctor';

  return (
    <div className="appointment-step appointment-step--datetime">
      <p className="appointment-step__title">Preferred date &amp; time</p>
      <p className="appointment-step__subtitle">
        Both are optional — our team will coordinate with the specialist and confirm your
        actual appointment time after your request.
      </p>

      <div className="datetime-summary">
        <div className="datetime-summary__row">
          <FaBriefcase className="icon" />
          <span className="datetime-summary__label">Doctor</span>
          <span className="datetime-summary__value">{fullName}</span>
        </div>
        <div className="datetime-summary__row">
          <FaRegClock className="icon" />
          <span className="datetime-summary__label">Duration</span>
          <span className="datetime-summary__value">30 min</span>
        </div>
        {(selectedDoctor?.clinicAddress || selectedDoctor?.city) && (
          <div className="datetime-summary__row">
            <FaLocationArrow className="icon" />
            <span className="datetime-summary__label">Location</span>
            <span className="datetime-summary__value">
              {[selectedDoctor.clinicName, selectedDoctor.clinicAddress, selectedDoctor.city].filter(Boolean).join(', ')}
            </span>
          </div>
        )}
        {(selectedDate || selectTime) && (
          <div className="datetime-summary__row">
            <FaCalendarAlt className="icon" />
            <span className="datetime-summary__label">Selected</span>
            <span className="datetime-summary__value">
              {selectedDate && moment(selectedDate).format('LL')}
              {selectTime && ` · ${selectTime}`}
            </span>
          </div>
        )}
      </div>

      <p className="appointment-step__subtitle" style={{ marginBottom: '0.5rem' }}>
        {selectedDate ? `Selected date: ${moment(selectedDate).format('LL')}` : 'Pick a date'}
      </p>
      <div className="datetime-dates">
        {next28Days.map((day) => {
          const isActive =
            selectedDate && moment(selectedDate).format('YYYY-MM-DD') === day.format('YYYY-MM-DD');
          return (
            <div
              key={day.valueOf()}
              className={`datetime-date-card ${isActive ? 'datetime-date-card--active' : ''}`}
              onClick={() => handleDateChange(day)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && handleDateChange(day)}
              aria-pressed={isActive}
            >
              <div className="day-num">{day.format('D')}</div>
              <div className="month-year">{day.format('MMM YYYY')}</div>
              <div className="weekday">{day.format('dddd')}</div>
            </div>
          );
        })}
      </div>

      <p className="appointment-step__subtitle" style={{ marginBottom: '0.5rem' }}>
        {selectTime
          ? `Preferred time of day: ${selectTime}`
          : 'Preferred time of day (optional)'}
      </p>
      <div className="datetime-times-section">
        <h4>Preferred time of day</h4>
        <div>
          {timePreferenceOptions.map((option) => (
            <Button
              key={option.value}
              type={option.value === selectTime ? 'primary' : 'default'}
              size="small"
              onClick={() => handleSelectTime(option.value)}
            >
              {option.label}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SelectApppointment;
